import React, { useEffect, useState, useCallback } from 'react';
import { FontProvider, useFontContext } from './context/FontContext.jsx';
import ControlPanel from './components/ControlPanel.jsx';
import FontList from './components/FontList.jsx';

function AppShell() {
  const [fonts, setFonts] = useState([]);
  const [status, setStatus] = useState('loading'); // loading | ready | error
  const [errorMessage, setErrorMessage] = useState(null);
  const { searchTerm } = useFontContext();


  const loadFonts = useCallback(async () => {
    setStatus('loading');
    setErrorMessage(null);
    try {
      const res = await fetch('/api/fonts');
      if (!res.ok) {
        throw new Error(`Server responded with ${res.status}`);
      }
      const data = await res.json();
      setFonts(Array.isArray(data.fonts) ? data.fonts : []);
      setStatus('ready');
    } catch (err) {
      console.error('Failed to load font manifest:', err);
      setErrorMessage(
        'Could not load the font library. Make sure the API server is running.'
      );
      setStatus('error');
    }
  }, []);

  useEffect(() => {
    loadFonts();
  }, [loadFonts]);

  const filteredFonts = fonts.filter(font => 
  font.family.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="flex min-h-screen flex-col bg-paper text-ink dark:bg-night dark:text-paper">
      <ControlPanel fontCount={filteredFonts.length} />

      {status === 'loading' && (
        <div className="flex flex-1 items-center justify-center">
          <p className="font-mono text-sm text-ink/50 dark:text-paper/50">
            Scanning font library…
          </p>
        </div>
      )}

      {status === 'error' && (
        <div className="flex flex-1 flex-col items-center justify-center gap-4 px-6 text-center">
          <p className="font-display text-lg">Something went wrong</p>
          <p className="max-w-sm font-sans text-sm text-ink/60 dark:text-paper/60">
            {errorMessage}
          </p>
          <button
            type="button"
            onClick={loadFonts}
            className="rounded-full border border-ink/20 px-4 py-1.5 font-mono text-xs hover:border-forest
                       hover:text-forest dark:border-paper/20 dark:hover:border-amber dark:hover:text-amber"
          >
            Try again
          </button>
        </div>
      )}

      {status === 'ready' && <FontList fonts={filteredFonts} />}
    </div>
  );
}

export default function App() {
  return (
    <FontProvider>
      <AppShell />
    </FontProvider>
  );
}
